import { useMemo, useState } from "react";
import { dailyQuestions, dayNumber } from "@/lib/daily";
import { readDaily, saveDaily, nudgeInstall } from "@/lib/engagement";
import { trackEvent } from "@/lib/analytics";

/** Daily Challenge state machine: current question, answer feedback, completion + persistence. */
export function useDailyGame(countries, lang) {
  const day = dayNumber();
  const questions = useMemo(() => dailyQuestions(countries, day), [countries, day]);
  const [saved, setSaved] = useState(() => readDaily(day));
  const [picks, setPicks] = useState([]);
  const [answered, setAnswered] = useState(null);
  const index = picks.length;
  const question = questions[index];

  const pick = (code) => {
    if (answered || !question) return;
    const correct = code === question.target.code;
    setAnswered({ picked: code, correct });
    trackEvent("daily_answer", { country_code: question.target.code, type: question.type, correct, lang });
  };

  const next = () => {
    const nextPicks = [...picks, answered.correct];
    setAnswered(null);
    setPicks(nextPicks);
    if (nextPicks.length !== questions.length) return;
    const { score, streak } = saveDaily(day, nextPicks);
    setSaved({ picks: nextPicks, score });
    trackEvent("daily_completed", { score, streak, lang });
    nudgeInstall();
  };

  return { day, questions, question, index, picks, answered, saved, isLast: index + 1 === questions.length, pick, next };
}

export const optionClass = (answered, isTarget, isPicked) => {
  if (!answered) return "border-stoneLine hover:bg-sandDeep/40";
  if (isTarget) return "border-oasis bg-oasis/10 text-oasis";
  return isPicked ? "border-ochre bg-ochre/10 text-ochre" : "border-stoneLine opacity-60";
};
